import Vue from 'vue';
import VueRouter from 'vue-router';

// const PageNotFound = () => import('../views/PageNotFound.vue');
// const Home = () => import('../views/layout/Layout.vue');
// // M01
// const M01 = () => import('../views/M01/M01.vue');
// // M01F01
// const M01F01 = () => import('../views/M01/MgrDataMaintenance/index.vue');
// const M01F01Index = () => import('../views/M01/MgrDataMaintenance/Views/index.vue');
// const M01F01Add = () => import('../views/M01/MgrDataMaintenance/Views/add.vue');
// const M01F01Edit = () => import('../views/M01/MgrDataMaintenance/Views/edit.vue');

// // M01F02
// const M01F02 = () => import('../views/M01/M01F02/index.vue');
// const M01F02Index = () => import('../views/M01/M01F02/Views/index.vue');
// const M01F02Add = () => import('../views/M01/M01F02/Views/add.vue');
// const M01F02Edit = () => import('../views/M01/M01F02/Views/edit.vue');

// const M01F03 = () => import('../views/M01/M01F03/index.vue');
// const M01F03Index = () => import('../views/M01/M01F03/Views/index.vue');
// // const M01F03Add = () => import('../views/M01/M01F03/Views/add.vue');
// const M01F03Edit = () => import('../views/M01/M01F03/Views/edit.vue');
// const M01F03PreView = () => import('../views/M01/M01F03/Components/Edit/PreView.vue');

// const M01F04 = () => import('../views/M01/M01F04/index.vue');
// const M01F04Index = () => import('../views/M01/M01F04/Views/index.vue');
// const M01F04Add = () => import('../views/M01/M01F04/Views/add.vue');
// const M01F04Edit = () => import('../views/M01/M01F04/Views/edit.vue');

// const M02 = () => import('../views/M02/M02.vue');
// const M02F01 = () => import('../views/M02/M02F01/index.vue');
// const M02F01Index = () => import('../views/M02/M02F01/Views/index.vue');
// const M02F01Add = () => import('../views/M02/M02F01/Views/add.vue');
// const M02F01Edit = () => import('../views/M02/M02F01/Views/edit.vue');

// const M02F02 = () => import('../views/M02/M02F02/index.vue');
// const M02F02Index = () => import('../views/M02/M02F02/Views/index.vue');
// const M02F02Add = () => import('../views/M02/M02F02/Views/add.vue');
// const M02F02Edit = () => import('../views/M02/M02F02/Views/edit.vue');

// const M03 = () => import('../views/M03/M03.vue');
// const M03F01 = () => import('../views/M03/M03F01/index.vue');
// const M03F01Index = () => import('../views/M03/M03F01/Views/index.vue');
// const M03F01Add = () => import('../views/M03/M03F01/Views/add.vue');
// const M03F01Edit = () => import('../views/M03/M03F01/Views/edit.vue');

// const M03F02 = () => import('../views/M03/M03F02/index.vue');
// const M03F02Index = () => import('../views/M03/M03F02/Views/index.vue');
// const M03F02Add = () => import('../views/M03/M03F02/Views/add.vue');
// const M03F02Edit = () => import('../views/M03/M03F02/Views/edit.vue');

// const M04 = () => import('../views/M04/M04.vue');
// const M04F01 = () => import('../views/M04/M04F01/index.vue');
// const M04F01Index = () => import('../views/M04/M04F01/Views/index.vue');
// const M04F01Add = () => import('../views/M04/M04F01/Views/add.vue');
// // const M04F01Edit = () => import('../views/M04/M04F01/Views/edit.vue');
// // const M04F01Preview = () => import('../views/M04/M04F01/Views/preview.vue');

// const M04F02 = () => import('../views/M04/M04F02/index.vue');
// const M04F02Index = () => import('../views/M04/M04F02/Views/index.vue');
// const M04F02Add = () => import('../views/M04/M04F02/Views/add.vue');
// // const M04F02Edit = () => import('../views/M04/M04F02/Views/edit.vue');

// const M05 = () => import('../views/M05/M05.vue');
// const M05F01 = () => import('../views/M05/M05F01/index.vue');
// const M05F01Index = () => import('../views/M05/M05F01/Views/index.vue');
// const M05F01Add = () => import('../views/M05/M05F01/Views/add.vue');
// const M05F01Edit = () => import('../views/M05/M05F01/Views/edit.vue');

// const M05F02 = () => import('../views/M05/M05F02/index.vue');
// const M05F02Index = () => import('../views/M05/M05F02/Views/index.vue');
// const M05F02Add = () => import('../views/M05/M05F02/Views/add.vue');
// const M05F02Edit = () => import('../views/M05/M05F02/Views/edit.vue');

// const M06 = () => import('../views/M06/M06.vue');
// const M06F01 = () => import('../views/M06/M06F01/index.vue');
// const M06F01Index = () => import('../views/M06/M06F01/Views/index.vue');
// const M06F01Add = () => import('../views/M06/M06F01/Views/add.vue');
// const M06F01Edit = () => import('../views/M06/M06F01/Views/edit.vue');

// const M06F02 = () => import('../views/M06/M06F02/index.vue');
// const M06F02Index = () => import('../views/M06/M06F02/Views/index.vue');
// const M06F02Add = () => import('../views/M06/M06F02/Views/add.vue');
// const M06F02Edit = () => import('../views/M06/M06F02/Views/edit.vue');

// const M06F03 = () => import('../views/M06/M06F03/index.vue');
// const M06F03Index = () => import('../views/M06/M06F03/Views/index.vue');
// const M06F03Add = () => import('../views/M06/M06F03/Views/add.vue');
// const M06F03Edit = () => import('../views/M06/M06F03/Views/edit.vue');

// const M06F04 = () => import('../views/M06/M06F04/index.vue');
// const M06F04Index = () => import('../views/M06/M06F04/Views/index.vue');
// const M06F04Add = () => import('../views/M06/M06F04/Views/add.vue');
// const M06F04Edit = () => import('../views/M06/M06F04/Views/edit.vue');

// const M07 = () => import('../views/M07/M07.vue');
// const M07F01 = () => import('../views/M07/M07F01/index.vue');
// const M07F01Index = () => import('../views/M07/M07F01/Views/index.vue');
// const M07F01Add = () => import('../views/M07/M07F01/Views/add.vue');
// const M07F01Edit = () => import('../views/M07/M07F01/Views/edit.vue');

// const M07F02 = () => import('../views/M07/M07F02/index.vue');
// const M07F02Index = () => import('../views/M07/M07F02/Views/index.vue');
// const M07F02Add = () => import('../views/M07/M07F02/Views/add.vue');
// const M07F02Edit = () => import('../views/M07/M07F02/Views/edit.vue');

// const M07F03 = () => import('../views/M07/M07F03/index.vue');
// const M07F03Index = () => import('../views/M07/M07F03/Views/index.vue');
// const M07F03Add = () => import('../views/M07/M07F03/Views/add.vue');
// const M07F03Edit = () => import('../views/M07/M07F03/Views/edit.vue');

// const M07F04 = () => import('../views/M07/M07F04/index.vue');
// const M07F04Index = () => import('../views/M07/M07F04/Views/index.vue');
// const M07F04Add = () => import('../views/M07/M07F04/Views/add.vue');
// const M07F04Edit = () => import('../views/M07/M07F04/Views/edit.vue');

// const M07F05 = () => import('../views/M07/M07F05/index.vue');
// const M07F05Index = () => import('../views/M07/M07F05/Views/index.vue');
// const M07F05Add = () => import('../views/M07/M07F05/Views/add.vue');
// const M07F05Edit = () => import('../views/M07/M07F05/Views/edit.vue');

// const M07F06 = () => import('../views/M07/M07F06/index.vue');
// const M07F06Index = () => import('../views/M07/M07F06/Views/index.vue');
// const M07F06Add = () => import('../views/M07/M07F06/Views/add.vue');
// const M07F06Edit = () => import('../views/M07/M07F06/Views/edit.vue');

// const M08 = () => import('../views/M08/M08.vue');
// const M08F01 = () => import('../views/M08/M08F01/index.vue');
// const M08F01Index = () => import('../views/M08/M08F01/Views/index.vue');
// const M08F01Add = () => import('../views/M08/M08F01/Views/add.vue');
// const M08F01Edit = () => import('../views/M08/M08F01/Views/edit.vue');

// const M08F02 = () => import('../views/M08/M08F02/index.vue');
// const M08F02Index = () => import('../views/M08/M08F02/Views/index.vue');
// const M08F02Add = () => import('../views/M08/M08F02/Views/add.vue');
// const M08F02Edit = () => import('../views/M08/M08F02/Views/edit.vue');

// const M08F03 = () => import('../views/M08/M08F03/index.vue');
// const M08F03Index = () => import('../views/M08/M08F03/Views/index.vue');
// const M08F03Add = () => import('../views/M08/M08F03/Views/add.vue');
// const M08F03Edit = () => import('../views/M08/M08F03/Views/edit.vue');

// const M09 = () => import('../views/M09/M09.vue');
// const M09F01 = () => import('../views/M09/M09F01/index.vue');
// const M09F01Index = () => import('../views/M09/M09F01/Views/index.vue');
// const M09F01Add = () => import('../views/M09/M09F01/Views/add.vue');
// const M09F01Edit = () => import('../views/M09/M09F01/Views/edit.vue');

// const M09F02 = () => import('../views/M09/M09F02/index.vue');
// const M09F02Index = () => import('../views/M09/M09F02/Views/index.vue');
// const M09F02Add = () => import('../views/M09/M09F02/Views/add.vue');
// const M09F02Edit = () => import('../views/M09/M09F02/Views/edit.vue');

// const M09F03 = () => import('../views/M09/M09F03/index.vue');
// const M09F03Index = () => import('../views/M09/M09F03/Views/index.vue');
// const M09F03Add = () => import('../views/M09/M09F03/Views/add.vue');
// const M09F03Edit = () => import('../views/M09/M09F03/Views/edit.vue');

// const M10 = () => import('../views/M10/M10.vue');
// const M10F01 = () => import('../views/M10/M10F01/index.vue');
// const M10F01Index = () => import('../views/M10/M10F01/Views/index.vue');
// const M10F01Add = () => import('../views/M10/M10F01/Views/add.vue');
// const M10F01Edit = () => import('../views/M10/M10F01/Views/edit.vue');

// const Breakpoints = () => import('../views/Breakpoints/Breakpoints.vue');

// const IconFont = () => import('../views/IconFont/IconFont.vue');

// const SystemSetting = () => import('../views/SystemSetting/index.vue');
// const ModuleManager = () => import('../views/SystemSetting/ModuleManager/index.vue');

Vue.use(VueRouter);

const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home,
//     children: [
//       {
//         path: 'PageNotFound',
//         name: 'PageNotFound',
//         component: PageNotFound,
//       },
//       // M01
//       {
//         path: 'M01',
//         component: M01,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '基本資料維護',
//         },
//         children: [
//           // M01F01
//           {
//             path: 'M01F01',
//             component: M01F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '管理者資料維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M01F01',
//                 component: M01F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '管理者資料維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M01F01Add',
//                 component: M01F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '管理者資料維護新增',
//                 },
//               },
//               {
//                 path: 'edit/:id',
//                 name: 'M01F01Edit',
//                 component: M01F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '管理者資料維護編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M01F02',
//             component: M01F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '駐診老師資料維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M01F02',
//                 component: M01F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師資料維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M01F02Add',
//                 component: M01F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師資料維護新增',
//                 },
//               },
//               {
//                 path: 'edit/:id?',
//                 name: 'M01F02Edit',
//                 component: M01F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師資料維護編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M01F03',
//             component: M01F03,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '學員資料維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M01F03',
//                 component: M01F03Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學員資料維護',
//                 },
//               },
//               // {
//               //   path: 'add',
//               //   name: 'M01F03Add',
//               //   component: M01F03Add,
//               //   meta: {
//               //     auth: 'Admin',
//               //     icon: 'user',
//               //     title: '學員資料維護新增',
//               //   },
//               // },
//               {
//                 path: 'edit',
//                 name: 'M01F03Edit',
//                 component: M01F03Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學員資料維護修改',
//                 },
//               },
//               {
//                 path: 'preView',
//                 name: 'M01F03PreView',
//                 component: M01F03PreView,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學員資料維護修改',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M01F04',
//             component: M01F04,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '校外學員資料維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M01F04',
//                 component: M01F04Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '校外學員資料維護',
//                 },
//               },
//               {
//                 path: 'add/:id?',
//                 name: 'M01F04Add',
//                 component: M01F04Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '校外學員資料維護新增',
//                 },
//               },
//               {
//                 path: 'edit/:id',
//                 name: 'M01F04Edit',
//                 component: M01F04Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '校外學員資料維護修改',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M02',
//         component: M02,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '駐診班表維護',
//         },
//         children: [
//           {
//             path: 'M02F01',
//             component: M02F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '駐診老師班表維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M02F01',
//                 component: M02F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師班表維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M02F01Add',
//                 component: M02F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師班表維護新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M02F01Edit',
//                 component: M02F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師班表維護編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M02F02',
//             component: M02F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '小老師資料維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M02F02',
//                 component: M02F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師資料維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M02F02Add',
//                 component: M02F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師資料維護新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M02F02Edit',
//                 component: M02F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師資料維護編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M03',
//         component: M03,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '請假作業維護',
//         },
//         children: [
//           {
//             path: 'M03F01',
//             component: M03F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '請假作業維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M03F01',
//                 component: M03F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '請假作業維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M03F01Add',
//                 component: M03F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '請假作業維護新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M03F01Edit',
//                 component: M03F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '請假作業維護編輯',
//                 },
//               },
//             ],
//           },
//           // M01F02
//           {
//             path: 'M03F02',
//             component: M03F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '小老師請假補班作業',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M03F02',
//                 component: M03F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師請假補班作業',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M03F02Add',
//                 component: M03F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師請假補班新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M03F02Edit',
//                 component: M03F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師請假補班修改',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M04',
//         component: M04,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '處方課程/講座維護',
//         },
//         children: [
//           {
//             path: 'M04F01',
//             component: M04F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '處方課程維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M04F01',
//                 component: M04F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程維護',
//                 },
//               },
//               {
//                 path: 'form',
//                 name: 'M04F01Add',
//                 component: M04F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程維護新增',
//                 },
//               },
//               // {
//               //   path: 'edit',
//               //   name: 'M04F01Edit',
//               //   component: M04F01Edit,
//               //   meta: {
//               //     auth: 'Admin',
//               //     icon: 'user',
//               //     title: '處方課程維護編輯',
//               //   },
//               // },
//               // {
//               //   path: 'preview',
//               //   name: 'M04F01Preview',
//               //   component: M04F01Preview,
//               //   meta: {
//               //     auth: 'Admin',
//               //     icon: 'user',
//               //     title: '處方課程維護檢視',
//               //   },
//               // },
//             ],
//           },
//           {
//             path: 'M04F02',
//             component: M04F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '講座維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M04F02',
//                 component: M04F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '講座維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M04F02Add',
//                 component: M04F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '講座維護新增',
//                 },
//               },
//               // {
//               //   path: 'edit',
//               //   name: 'M04F02Edit',
//               //   component: M04F02Edit,
//               //   meta: {
//               //     auth: 'Admin',
//               //     icon: 'user',
//               //     title: '講座維護編輯',
//               //   },
//               // },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M05',
//         component: M05,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '問卷資料維護',
//         },
//         children: [
//           {
//             path: 'M05F01',
//             component: M05F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '學習問卷',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M05F01',
//                 component: M05F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學習問券 ',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M05F01Add',
//                 component: M05F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學習問券新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M05F01Edit',
//                 component: M05F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學習問券 編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M05F02',
//             component: M05F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '滿意度問卷',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M05F02',
//                 component: M05F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '滿意度問卷',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M05F02Add',
//                 component: M05F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '滿意度問卷新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M05F02Edit',
//                 component: M05F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '滿意度問卷編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M06',
//         component: M06,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '各項目簽到作業',
//         },
//         children: [
//           {
//             path: 'M06F01',
//             component: M06F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '駐診老師簽到',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M06F01',
//                 component: M06F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師簽到',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M06F01Add',
//                 component: M06F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師簽到新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M06F01Edit',
//                 component: M06F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '駐診老師簽到編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M06F02',
//             component: M06F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '小老師簽到',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M06F02',
//                 component: M06F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師簽到',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M06F02Add',
//                 component: M06F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師簽到新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M06F02Edit',
//                 component: M06F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '小老師簽到編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M06F03',
//             component: M06F03,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '自學軟體簽到',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M06F03',
//                 component: M06F03Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學軟體簽到',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M06F03Add',
//                 component: M06F03Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學軟體簽到新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M06F03Edit',
//                 component: M06F03Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學軟體簽到編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M06F04',
//             component: M06F04,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '處方課程/講座',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M06F04',
//                 component: M06F04Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程/講座',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M06F04Add',
//                 component: M06F04Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程/講座新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M06F04Edit',
//                 component: M06F04Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程/講座編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M07',
//         component: M07,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '處方簽紀錄維護',
//         },
//         children: [
//           {
//             path: 'M07F01',
//             component: M07F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '診斷諮商',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M07F01',
//                 component: M07F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '診斷諮商',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M07F01Add',
//                 component: M07F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '診斷諮商新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M07F01Edit',
//                 component: M07F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '診斷諮商編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M07F02',
//             component: M07F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '簡報練習',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M07F02',
//                 component: M07F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '簡報練習',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M07F02Add',
//                 component: M07F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '簡報練習新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M07F02Edit',
//                 component: M07F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '簡報練習編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M07F03',
//             component: M07F03,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '口說練習',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M07F03',
//                 component: M07F03Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '口說練習',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M07F03Add',
//                 component: M07F03Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '口說練習新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M07F03Edit',
//                 component: M07F03Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '口說練習編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M07F04',
//             component: M07F04,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '寫作諮商',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M07F04',
//                 component: M07F04Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '寫作諮商',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M07F04Add',
//                 component: M07F04Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '寫作諮商新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M07F04Edit',
//                 component: M07F04Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '寫作諮商編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M07F05',
//             component: M07F05,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '自學療程',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M07F05',
//                 component: M07F05Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學療程',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M07F05Add',
//                 component: M07F05Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學療程新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M07F05Edit',
//                 component: M07F05Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學療程編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M07F06',
//             component: M07F06,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '處方課程/講座',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M07F06',
//                 component: M07F06Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程/講座',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M07F06Add',
//                 component: M07F06Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程/講座新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M07F06Edit',
//                 component: M07F06Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '處方課程/講座編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M08',
//         component: M08,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '數據報表查詢',
//         },
//         children: [
//           {
//             path: 'M08F01',
//             component: M08F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '註冊紀錄',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M08F01',
//                 component: M08F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '註冊紀錄',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M08F01Add',
//                 component: M08F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '註冊紀錄新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M08F01Edit',
//                 component: M08F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '註冊紀錄編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M08F02',
//             component: M08F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '輔導項目紀錄',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M08F02',
//                 component: M08F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '輔導項目紀錄',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M08F02Add',
//                 component: M08F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '輔導項目紀錄新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M08F02Edit',
//                 component: M08F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '輔導項目紀錄編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M08F03',
//             component: M08F03,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '學習紀錄',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M08F03',
//                 component: M08F03Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學習紀錄',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M08F03Add',
//                 component: M08F03Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學習紀錄新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M08F03Edit',
//                 component: M08F03Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '學習紀錄編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M09',
//         component: M09,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '後台設定',
//         },
//         children: [
//           {
//             path: 'M09F01',
//             component: M09F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '基本設定維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M09F01',
//                 component: M09F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '基本設定維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M09F01Add',
//                 component: M09F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '基本設定維護新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M09F01Edit',
//                 component: M09F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '基本設定維護編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M09F02',
//             component: M09F02,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '療程資料維護',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M09F02',
//                 component: M09F02Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '療程資料維護',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M09F02Add',
//                 component: M09F02Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學療程資料維護新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M09F02Edit',
//                 component: M09F02Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '自學療程資料維護編輯',
//                 },
//               },
//             ],
//           },
//           {
//             path: 'M09F03',
//             component: M09F03,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '人員權限設定',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M09F03',
//                 component: M09F03Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '人員權限設定',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M09F03Add',
//                 component: M09F03Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '老師/小老師設定維護新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M09F03Edit',
//                 component: M09F03Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '老師/小老師設定維護編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'M10',
//         component: M10,
//         alias: [''],
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '整體表現',
//         },
//         children: [
//           {
//             path: 'M10F01',
//             component: M10F01,
//             alias: [''],
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '整體表現',
//             },
//             children: [
//               {
//                 path: '',
//                 name: 'M10F01',
//                 component: M10F01Index,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '整體表現',
//                 },
//               },
//               {
//                 path: 'add',
//                 name: 'M10F01Add',
//                 component: M10F01Add,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '整體表現新增',
//                 },
//               },
//               {
//                 path: 'edit',
//                 name: 'M10F01Edit',
//                 component: M10F01Edit,
//                 meta: {
//                   auth: 'Admin',
//                   icon: 'user',
//                   title: '整體表現編輯',
//                 },
//               },
//             ],
//           },
//         ],
//       },
//       {
//         path: 'Breakpoints',
//         name: 'Breakpoints',
//         component: Breakpoints,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: 'Breakpoints',
//         },
//         // Breakpoints
//       },
//       {
//         path: 'IconFont',
//         name: 'IconFont',
//         component: IconFont,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: 'Breakpoints',
//         },
//         // Breakpoints
//       },
//       {
//         path: 'SystemSetting',
//         name: 'SystemSetting',
//         component: SystemSetting,
//         meta: {
//           auth: 'Admin',
//           icon: 'user',
//           title: '基礎設定',
//         },
//         children: [
//           {
//             path: 'ModuleManager',
//             name: 'ModuleManager',
//             component: ModuleManager,
//             meta: {
//               auth: 'Admin',
//               icon: 'user',
//               title: '模組管理',
//             },
//           },
//         ],
//       },
//     ],
//   },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
